var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgClosedEye = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 22,
  height: 17,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#98918A",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M9.73 2.439A13 13 0 0 1 11 2.375c4.664 0 8.4 2.54 10 6.125a9.9 9.9 0 0 1-1.555 2.44M5.52 3.704C3.48 4.794 1.9 6.48 1 8.5c1.6 3.585 5.336 6.125 10 6.125 2.038 0 3.898-.485 5.48-1.33M8.88 6.644C8.336 7.119 8 7.775 8 8.5c0 1.45 1.343 2.625 3 2.625.829 0 1.579-.294 2.121-.769"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#98918A",
  strokeLinecap: "round",
  strokeWidth: 1.5,
  d: "m3 1.5 16 14"
})));
export default SvgClosedEye;